module.exports = __webpack_public_path__ + "img/teaching-7.3810f2b2.png";